import React, { useEffect, useState } from "react";
import Tabs from "../Tabs/Tabs";
import { getPhaseTitle, getActivities, isPhaseValidate } from "./FormFormat";

const FormByTabs = (props) => {
  const { touched, phases, phaseNo, errors, formShowPendingCount } = props;
  const [activeTab, setActiveTab] = useState(0);

  useEffect(() => {
    const activePhase = phases.find((phase) => phase.phaseNo == phaseNo);
    if (activePhase?.phaseNo) {
      setActiveTab(activePhase.phaseNo);
    }
  }, [phaseNo]);

  return (
    <Tabs activeTab={activeTab} setActiveTab={setActiveTab}>
      {phases.map((phase) => {
        const { phaseNo, title, description, elements } = phase;
        return (
          <div
            key={phaseNo}
            className={
              isPhaseValidate(elements, touched, errors)
                ? "dcrfrom-tabs__option--validate"
                : ""
            }
            id={phaseNo}
            label={getPhaseTitle(title, elements, formShowPendingCount)}
          >
            {getActivities({
              touched,
              errors,
              description,
              elements,
              ...props,
              phaseNo,
            })}
          </div>
        );
      })}
    </Tabs>
  );
};

export default FormByTabs;
